<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <div class="grid lg:gap-x-4 grid-cols-1 lg:grid-cols-2">
                    <ResultList>
                        <li class="flex justify-between text-gray-900">
                            <p>{{ data.after.repayType==='1'?'全部清償':'' }} {{ data.after.repayType==='2'?'部分清償':'' }}</p>
                        </li>
                        <template v-if="data.after.repayType==='1'">
                            <li class="flex justify-between items-center text-gray-700">
                                <p class="text-xs">
                                    自動墊繳保費本金
                                </p>
                                <p class="text-lg">
                                    {{ addComma(data.after.autoPremLoanCapital) }}
                                </p>
                            </li>
                            <li class="flex justify-between items-center text-gray-700">
                                <p class="text-xs ">
                                    自動墊繳保費利息
                                </p>
                                <p class="text-lg">
                                    {{ addComma(data.after.autoPremLoanInterest) }}
                                </p>
                            </li>
                        </template>
                        <template v-if="data.after.repayType==='2'">
                            <li class="flex justify-between items-center text-gray-700">
                                <p class="text-xs ">
                                    欲償還金額
                                </p>
                                <p class="text-lg">
                                    {{ addComma(data.after.premAmount) }}
                                </p>
                            </li>
                        </template>
                    </ResultList>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';
import { addComma } from '@/utils/number/addComma';

export default {
    name: 'C2Data',
    components: {
        CollapseConfirmData,
        ResultList
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('C2');
        const removeService = () => {
            emit('removeService', code.value);
        };

        return {
            code,
            data,
            removeService,
            addComma
        };
    },
};
</script>
